__turbopack_context__.v({
  "className": "poppins_d9f9dfcf-module__PKMZSa__className",
  "variable": "poppins_d9f9dfcf-module__PKMZSa__variable",
});
